import React, { useState, useEffect } from 'react';
import { Popover, Box } from '@mui/material';
import { GetStudy, GetToken } from '../../../../api';
import DetailPanelContent from '../shared/DetailPanelContent';
import ReportingData from '../Studies/Teleconsulation/Respond/ReportingData';
import PdfPreview from '../shared/PdfPreview';

export default function StudyTagPopover({ anchorEl, onClose, studyId, patientId, orgId }) {
  const [study, setStudy] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfStudyId, setPdfStudyId] = useState(null);

  useEffect(() => {
    if (anchorEl && studyId) {
      GetStudy(studyId, { org: orgId }).then(setStudy).catch(() => {});
    }
  }, [anchorEl, studyId, orgId]);

  const medDream = (StudyInstanceUID) => {
    GetToken({ data: StudyInstanceUID }).then(result => {
      const { accessToken } = result;
      accessToken && window.open(`https://dream.pacs.corridor.vet/?token=${accessToken}`, '_blank');
    }).catch(() => {});
  };

  const setPdfDialogState = ({ studyId }) => {
    setShowPdf(true);
    setPdfStudyId(studyId);
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      PaperProps={{
        sx: { width: 800, maxHeight: 600, overflow: 'auto' }
      }}
    >
      <Box sx={{ width: 800 }}>
        {study && <>
          <ReportingData study={study} section="consult" hideFreeze hideConsult sx={{ px: 1.5, pt: 2 }} />
          <DetailPanelContent org={orgId} row={study} setPdfDialogState={setPdfDialogState} medDream={medDream} />
        </>}
        {showPdf && (
          <Box sx={{ width: 800, height: 600 }}>
            <PdfPreview open={true} studyId={pdfStudyId} setDialogState={() => setShowPdf(false)} />
          </Box>
        )}
      </Box>
    </Popover>
  );
}
